<template>   
    <h3 v-if="!loading" class="flex my-3 text-xl leading-6 font-large dark:text-white item-center">
        <store-modal
            @fetch="fetch"
            :featureFlags="featureFlags"
            @resetFeatureFlags="featureFlags = null;"
        />
    </h3>
    
    <div v-if="!loading && featureFlags.length > 0" class="mb-2 mt-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full sm:px-6 lg:px-8">
            <div class="relative overflow-hidden rounded-xl bg-slate-50 dark:bg-slate-800/25">
                <table class="w-full table-auto border-collapse text-sm">
                    <thead>
                        <tr>
                            <th
                                scope="col"
                                class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200"
                                width="80px"
                            >
                                Ações
                            </th>
                            <th
                                scope="col"
                                class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200"
                            >
                                Nome da Feature
                            </th>
                            <th
                                scope="col"
                                class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200"
                                width="120px"
                            >
                                Status
                            </th>
                            <th
                                scope="col"
                                class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200"
                                width="180px"
                            >
                                Data de Criação
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-slate-800">
                        <tr v-for="featureFlag in featureFlags" :key="featureFlag.id">
                            <td class="table-cell-sm">
                                <button
                                    @click="destroy(featureFlag)"
                                    :disabled="loading"
                                    class="text-red-600 hover:text-red-800 text-sm font-medium"
                                    :class="{ 'cursor-not-allowed opacity-50': loading }"
                                >
                                    Excluir
                                </button>
                            </td>
                            <td class="table-cell-sm" style="padding:0.75rem">
                                <span
                                    :title="featureFlag.name"
                                    class="block"
                                >
                                    {{ featureFlag.name }}
                                </span>
                            </td>
                            <td class="table-cell-sm">
                                <button
                                    @click="toggle(featureFlag)"
                                    :disabled="loading"
                                    class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                                    :class="featureFlag.is_active ? 'bg-indigo-600' : 'bg-gray-200'"
                                >
                                    <span class="sr-only">{{ featureFlag.is_active ? 'Desativar' : 'Ativar' }}</span>
                                    <span
                                        aria-hidden="true"
                                        class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                                        :class="featureFlag.is_active ? 'translate-x-5' : 'translate-x-0'"
                                    ></span>
                                </button>
                            </td>
                            <td class="table-cell-sm">
                                <span
                                    :title="featureFlag.created_at"
                                    class="block"
                                >
                                    {{ featureFlag.created_at }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <empty-state class="mt-4" v-if="!loading && !featureFlags.length" />

    <div v-if="loading">
        <h3 class="my-3 text-sm font-bold font-medium text-gray-400">
            Buscando registros...
        </h3>
    </div>

    <!-- Edit Modal -->
    <!-- Modal removido - edição não é mais necessária -->
</template>

<script>
    import { useToast } from "vue-toastification";
    import EmptyState from "../../components/layouts/EmptyState.vue";
    import StoreModal from "../../components/config/modals/FeatureFlagStoreModal.vue";
    import TictoLoading from "../../components/layouts/TictoLoading.vue";

    export default {
        components: {
            EmptyState,
            StoreModal,
            TictoLoading,
        },

        data() {
            return {
                loading: true,
                featureFlags: [],
                next_page_url: false,
                pagination: {
                    total: 0,
                    per_page: 10,
                    current_page: 1,
                    last_page: 11,
                    from: 1,
                    to: 11,
                },
            }
        },

        setup() {
            const toast = useToast();
            return { toast };
        },

        mounted() {
            this.fetch();
        },

        methods: {
            fetch() {
                let params = {};
                params["page"] = this.pagination.current_page;

                this.loading = true;
                axios
                    .get('/api/feature-flags', {
                        params: params
                    })
                    .then(({data}) => {
                        this.featureFlags = data.data;
                        this.pagination = {
                            ...this.pagination,
                            ...data.links,
                            ...data.meta,
                        };
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            toggle(featureFlag) {
                let questionText = featureFlag.is_active 
                    ? 'Tem certeza que deseja desativar esta feature flag?' 
                    : 'Tem certeza que deseja ativar esta feature flag?';
                let successText = featureFlag.is_active 
                    ? 'Feature flag desativada com sucesso!' 
                    : 'Feature flag ativada com sucesso!';
                
                if (confirm(questionText)) {
                    this.loading = true;
                    axios
                        .put(`/api/feature-flags/${featureFlag.id}/toggle`)
                        .then(({ data }) => {
                            if (data ?? null) {
                                this.toast.success(successText);
                                this.fetch();
                            }
                        })
                        .catch(({response: {data: { message }}}) => {
                            this.toast.error(message);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
            destroy(featureFlag) {
                if (confirm('Tem certeza que deseja excluir esta feature flag?')) {
                    this.loading = true;
                    axios
                        .delete(`/api/feature-flags/${featureFlag.id}`)
                        .then(({ data }) => {
                            if (data ?? null) {
                                this.toast.success("Feature flag excluída com sucesso!");
                                this.fetch();
                            }
                        })
                        .catch(({response: {data: { message }}}) => {
                            this.toast.error(message);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
        }
    }
</script>